import { Instance } from 'mobx-state-tree';
import { OrderCompletedDtoModelBase } from './OrderCompletedDtoModel.base';

/* The TypeScript type of an instance of OrderCompletedDtoModel */
export interface OrderCompletedDtoModelType extends Instance<typeof OrderCompletedDtoModel.Type> {}

/* A graphql query fragment builders for OrderCompletedDtoModel */
export { selectFromOrderCompletedDto, orderCompletedDtoModelPrimitives, OrderCompletedDtoModelSelector } from './OrderCompletedDtoModel.base';

/**
 * OrderCompletedDtoModel
 */
export const OrderCompletedDtoModel = OrderCompletedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
